export const SET_NEW_SETTINGS = '[settings] SET_NEW_SETTINGS'
export const SET_IS_LOADING_SETTINGS = '[settings] SET_IS_LOADING_SETTINGS'
export const GET_IS_LOADING_SETTINGS = '[settings] GET_IS_LOADING_SETTINGS'
export const SET_UNLOAD_INFO = '[settings] SET_UNLOAD_INFO'
export const GET_UNLOAD_INFO = '[settings] GET_UNLOAD_INFO'
export const FETCH_UNLOAD_INFO = '[settings] SET_UNLOAD_INFO'
